import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("iem_cookie_consent")) {
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("iem_cookie_consent", "accepted");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 48 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 48 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-4 bottom-4 z-[90] sm:inset-x-auto sm:bottom-6 sm:right-6 sm:max-w-md"
          data-testid="cookie-banner"
        >
          <div className="border border-[#2a2a2a] border-t-gold/40 bg-[#0d0d0d]/95 p-6 shadow-[0_20px_60px_rgba(0,0,0,0.6)] backdrop-blur-xl sm:p-7">
            <p className="text-[13px] leading-relaxed text-[#969696]">
              Questo sito utilizza cookie tecnici strettamente necessari al corretto funzionamento e alla
              navigazione. Non vengono impiegati cookie di profilazione o tracciamento pubblicitario. Per maggiori
              informazioni consulta la nostra Cookie Policy.
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-4">
              <button
                data-testid="cookie-accept-btn"
                onClick={accept}
                className="bg-gold px-6 py-3 text-[12px] font-bold uppercase tracking-[0.16em] text-[#080808] transition-colors duration-300 hover:bg-gold-bright"
              >
                Accetta e Chiudi
              </button>
              <Link
                data-testid="cookie-policy-link"
                to="/cookie-policy"
                className="text-[12px] font-semibold uppercase tracking-[0.16em] text-[#969696] transition-colors hover:text-gold"
              >
                Cookie Policy
              </Link>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
